import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="result-form"
export default class extends Controller {
  static targets = ["aggregationLevel", "productField"]

  connect() {
    this.toggleProductField()
  }

  toggleProductField() {
    const aggregationLevel = this.aggregationLevelTarget.value

    if (aggregationLevel === 'by_product') {
      this.productFieldTarget.style.display = 'block'
    } else {
      this.productFieldTarget.style.display = 'none'
    }
  }
}
